import { DocumentNode, gql } from '@apollo/client';

export const CalculateCharges: DocumentNode = gql`
    mutation CalculateCharges($input: CalculateChargesInput!) {
        calculateCharges(input: $input) {
            estimatedCharges {
                thisAccount {
                    amount
                }
                includingLinkedAccounts {
                    amount
                }
            }
            tieredPlatformCharge {
                thisAccount {
                    amount
                    percent
                }
                includingLinkedAccounts {
                    amount
                    percent
                }
            }
            savingsFromLinkedAccounts {
                amount
                percent
            }
            tiers {
                min
                max
                pensionRate
                isaRate
                giaRate
            }
        }
    }
`;
